import { createGlobalStyle } from 'styled-components';

export const WlePartnersFonts = createGlobalStyle`
  :root {
    --heading-font-family: 'Reckless Neue', sans-serif;
  }
  
  @font-face {
    font-family: 'Reckless Neue';
    font-weight: 400;
    src: url('https://reeltimeprod-ahebbuatfggte7f2.z01.azurefd.net/partners/RecklessNeue-Regular.otf') format('opentype');
  }
  
  @font-face {
    font-family: 'Reckless Neue';
    font-weight: 300;
    src: url('https://reeltimeprod-ahebbuatfggte7f2.z01.azurefd.net/partners/RecklessNeue-Thin.otf') format('opentype');
  }

  * {
    -webkit-font-smoothing: antialiased;
  }
`;
